import React from "react";

export const CONTACT_COPY = {
  en: {
    lastName: "Last name",
    streetAddress: "Street address",
    city: "City",
    region: "Province / state / region",
    postalCode: "Postal / ZIP code",
    telephone: "Telephone number",
    ageConfirm: "I confirm that I am 18 years of age or older.",
    contactPurpose: "We use this contact information to administer and help verify your account, communicate with you about the service, and contact you about account or security matters when necessary.",
  },
  "pt-BR": {
    lastName: "Sobrenome",
    streetAddress: "Endereço",
    city: "Cidade",
    region: "Estado / província / região",
    postalCode: "CEP / código postal",
    telephone: "Telefone",
    ageConfirm: "Confirmo que tenho 18 anos de idade ou mais.",
    contactPurpose: "Usamos estas informações de contato para administrar e ajudar a verificar sua conta, comunicar-nos sobre o serviço e entrar em contato sobre questões da conta ou de segurança quando necessário.",
  },
  "es-419": {
    lastName: "Apellido",
    streetAddress: "Dirección",
    city: "Ciudad",
    region: "Estado / provincia / región",
    postalCode: "Código postal",
    telephone: "Número de teléfono",
    ageConfirm: "Confirmo que tengo 18 años de edad o más.",
    contactPurpose: "Usamos esta información de contacto para administrar y ayudar a verificar su cuenta, comunicarnos con usted sobre el servicio y contactarlo por asuntos de la cuenta o de seguridad cuando sea necesario.",
  },
  "fr-CA": {
    lastName: "Nom de famille",
    streetAddress: "Adresse",
    city: "Ville",
    region: "Province / État / région",
    postalCode: "Code postal / ZIP",
    telephone: "Numéro de téléphone",
    ageConfirm: "Je confirme avoir 18 ans ou plus.",
    contactPurpose: "Nous utilisons ces coordonnées pour administrer et aider à vérifier votre compte, communiquer avec vous au sujet du service et vous joindre au besoin pour des questions liées au compte ou à la sécurité.",
  },
};

export function getContactCopy(locale) {
  return CONTACT_COPY[locale] || CONTACT_COPY.en;
}

function Field({ label, value, onChange, testId, autoComplete, type = "text" }) {
  return (
    <label className="block">
      <span className="block text-xs font-medium text-[color:var(--text-secondary)] mb-1">{label}</span>
      <input
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        className="w-full rounded-lg border border-[color:var(--border-stone)] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--brand)]"
        data-testid={testId}
      />
    </label>
  );
}

export function ContactAccountFields({
  locale,
  lastName,
  setLastName,
  streetAddress,
  setStreetAddress,
  city,
  setCity,
  region,
  setRegion,
  postalCode,
  setPostalCode,
  telephone,
  setTelephone,
}) {
  const t = getContactCopy(locale);
  return (
    <>
      <Field label={t.lastName} value={lastName} onChange={setLastName} testId="contact-last-name" autoComplete="family-name" />
      <Field label={t.streetAddress} value={streetAddress} onChange={setStreetAddress} testId="contact-street-address" autoComplete="street-address" />
      <Field label={t.city} value={city} onChange={setCity} testId="contact-city" autoComplete="address-level2" />
      <Field label={t.region} value={region} onChange={setRegion} testId="contact-region" autoComplete="address-level1" />
      <Field label={t.postalCode} value={postalCode} onChange={setPostalCode} testId="contact-postal-code" autoComplete="postal-code" />
      <Field label={t.telephone} value={telephone} onChange={setTelephone} testId="contact-telephone" autoComplete="tel" type="tel" />
    </>
  );
}
